<form [formGroup]="form" (submit)="onSubmit($event)">
  <ng-container *ngFor="let field of fields" lhDynamicFormField [config]="field" [group]="form"></ng-container>
</form>
